import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './editorial/fonts.css';
import './editorial/experience.scss';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
